export const LARGE_AMOUNT_THRESHOLD = 300;

// Compares in grosze so "450", "450,00" and "450.0" count as the same amount.
function toGrosze(value) {
  if (value === null || value === undefined) {
    return null;
  }
  const normalized = String(value).replace(/\s/g, "").replace(",", ".");
  if (normalized === "") {
    return null;
  }
  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? Math.round(parsed * 100) : null;
}

export function requiresAmountConfirmation(amount) {
  const grosze = toGrosze(amount);
  return grosze !== null && grosze > LARGE_AMOUNT_THRESHOLD * 100;
}

export function amountsMatch(entered, expected) {
  const enteredGrosze = toGrosze(entered);
  return enteredGrosze !== null && enteredGrosze === toGrosze(expected);
}
